export default "__VITE_ASSET__kE9OkOlc__"